const Codes = {
  markCode: 'spud',
  elizabeth: 'majestic',
};

export const isCodeAuthentic = (code) => Object.values(Codes).includes(code?.toLowerCase());

export default Codes;